import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors } = theme.busbud;

  return {
    button: {
      backgroundColor: colors.palette.teal.regular[600],
      "&:hover": {
        backgroundColor: colors.palette.teal.regular[500]
      }
    }
  };
});
